import { CryptoProps } from '@/types';

export class BaseSecurityCrypto {
  publicRawKeyBase64: string | undefined;
  protected _public_key: string | undefined;
  protected _private_key: string | undefined;

  constructor(props: CryptoProps) {
    this._private_key = props.privateKey;
    this._public_key = props.publicKey;
  }

  getKeys(): { publicKey?: string; privateKey?: string; publicRawKeyBase64?: string } {
    return {
      publicKey: this._public_key,
      privateKey: this._private_key,
      publicRawKeyBase64: this.publicRawKeyBase64
    };
  }

  // eslint-disable-next-line require-await
  async sign(sign_str: string): Promise<string> {
    return '';
  }
}
